(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    




  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {

      this.firstload=true;
      this.header = document.querySelector('.section-header');
      this.banner = document.querySelector('.banner');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      this.checkScroll = () => {
        if (window.scrollY <= this.header.offsetHeight) {
          this.header.classList.add('top');
        } else {
          this.header.classList.remove('top');
        }
      };

      window.addEventListener('scroll', this.checkScroll);
      this.checkScroll(); // Initial check
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(document.body.classList.contains('template-index')||
      document.body.classList.contains('template-page') ||
      document.body.classList.contains('template-404') ? this.banner : this.header);
    }

    onScroll() {

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      let headerOffset = document.body.classList.contains('template-index')||
      document.body.classList.contains('template-page')||
      document.body.classList.contains('template-404')? this.headerBounds.bottom : this.headerBounds.top;

      if (scrollTop > this.currentScrollTop && scrollTop > headerOffset) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerOffset) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= headerOffset) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky'); //'shopify-section-header-hidden',
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-sticky', 'animate'); //'shopify-section-header-hidden',
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  function checkBarColor() {
    // If the page URL contains the words "collections", "product", or "pages", the color of the element cannot change
    if (
      window.location.href.indexOf("collections") > -1 ||
      window.location.href.indexOf("product") > -1 ||
      window.location.href.indexOf("pages") > -1
    ) {
      return; // Exit the function early without changing the color
    }

  }
  checkBarColor();
  //add an event listener to the window object that listens for the resize event

  window.addEventListener('scroll', function() {
    checkBarColor();
  });
  //if an element of id help-button is clicked, the item with class menu-phones is shown

  customElements.define('sticky-header', StickyHeader);


  // document.querySelector('#menu-currency').style.display = '';
  const menuPhones = document.querySelector('#menu-phones');
  const menuCountriesCurrency = document.querySelector('#menu-countries-currency');
  if(menuPhones) menuPhones.style.display = '';
  if(menuCountriesCurrency) menuCountriesCurrency.style.display = '';


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-product-information"] && !Shopify.designMode) return;
  try {
    
  // $(document).ready(function () {
  //   $('div').click(function () {
  //     $(this).toggleClass('show_class');
  //   });
  // });

  // var elem = document.querySelector('.carousel-main');
  // var flkty = new Flickity(elem, {
  //   cellAlign: 'left',
  //   contain: true,
  //   prevNextButtons: false,
  //   pageDots: false,
  // });

  // element argument can be a selector string
  //   for an individual element
  // var flkty = new Flickity('.carousel-main', {
  //   // options
  //   pageDots: false,
  // });
  // Initialize;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
      //window.bindCollectionEvents();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"] .product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rocket-brands-slider"] && !Shopify.designMode) return;
  try {
    
    $(".brand-slider__container--slides").slick({
        infinite: false,
        slidesToShow: 11,
        centerMode: false,
        variableWidth: false,
        dots: false,
        arrows: true,
        prevArrow:
        '<a class="brand-slider__container--arrows__arrow prev" aria-label="' +
        theme.strings.previous +
        '">' +
        theme.icons.chevronLeft +
        "</a>",
        nextArrow:
        '<a class="brand-slider__container--arrows__arrow next" aria-label="' +
        theme.strings.next +
        '">' +
        theme.icons.chevronRight +
        "</a>",
        appendArrows: $(".brand-slider__container--arrows"),
        responsive: [
          {
            breakpoint: 576,
            settings: {
                slidesToShow: 2
            }
          }
        ]
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rocket-como-personalizar-ropa"] && !Shopify.designMode) return;
  try {
    
    $(".personalizar-ropa__container--text a").on("click", function(e) {
        e.preventDefault()
        $(".personalizar-ropa__popup").removeClass("display-none");
      })

      $(".personalizar-ropa__popup--container__header--close").on("click", function() {
        $(".personalizar-ropa__popup").addClass("display-none");
      })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rocket-home-slider-changing-banner"] && !Shopify.designMode) return;
  try {
    

  function createBannerNextClickEvent() {
    nextArrow.addEventListener('click', function () {
      if (container.childNodes[slide].classList.contains('visible') && container.childNodes[slide].nodeName == 'DIV') {
        container.childNodes[slide].classList.toggle('visible');
        slide += 2;
        if ( slide > container.childNodes.length - 1) {
          slide = 1;
        }
        container.childNodes[slide].classList.toggle('visible');
      } else {
        slide = 1;
      }
    });
  };
  function createBannerPrevClickEvent() {
    prevArrow.addEventListener('click', function () {
      if (container.childNodes[slide].classList.contains('visible') && container.childNodes[slide].nodeName == 'DIV') {
        container.childNodes[slide].classList.toggle('visible');
        slide -= 2;
        if ( slide < 1) {
          slide = container.childNodes.length - 2;
        }
        container.childNodes[slide].classList.toggle('visible');
      } else {
        slide = container.childNodes.length;
      }
    });
  };
  let slide = 1;
  let container = document.querySelector('#homeChangingBanner').querySelector(".homeChangingBanner-mainContainer");
  const blockSize = container.getAttribute('section-blocks-size');
  let nextArrow = document.querySelector('#homeChangingBanner').querySelector('.next');
  let prevArrow = document.querySelector('#homeChangingBanner').querySelector('.prev');
  container.childNodes[slide].classList.toggle('visible');
  createBannerNextClickEvent(); 
  createBannerPrevClickEvent(); 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rocket-image-banner-50-50"] && !Shopify.designMode) return;
  try {
    
  function createBannerNextClickEvent() {
    nextArrow.addEventListener('click', function () {
      if (container.childNodes[slide].classList.contains('visible') && container.childNodes[slide].nodeName == 'DIV') {
        container.childNodes[slide].classList.toggle('visible');
        slide += 2;
        if (slide > container.childNodes.length - 1) {
          slide = 1;
        }
        container.childNodes[slide].classList.toggle('visible');
      } else {
        slide = 1;
      }
    });
  }
  function createBannerPrevClickEvent() {
    prevArrow.addEventListener('click', function () {
      if (container.childNodes[slide].classList.contains('visible') && container.childNodes[slide].nodeName == 'DIV') {
        container.childNodes[slide].classList.toggle('visible');
        slide -= 2;
        if (slide < 1) {
          slide = container.childNodes.length - 2;
        }
        container.childNodes[slide].classList.toggle('visible');
      } else {
        slide = container.childNodes.length;
      }
    });
  }
  let slide = 1;
  let container = document.querySelector('#imageBanner50').querySelector('.imageBanner50-mainContainer');
  const blockSize = container.getAttribute('section-blocks-size');
  let nextArrow = document.querySelector('#imageBanner50').querySelector('.next');
  let prevArrow = document.querySelector('#imageBanner50').querySelector('.prev');
  container.childNodes[slide].classList.toggle('visible');
  createBannerNextClickEvent();
  createBannerPrevClickEvent();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rocket-size-chart-filter"] && !Shopify.designMode) return;
  try {
    
const brandContainer = document.querySelectorAll(".size-chart__filter--container");
const brand = document.querySelectorAll(".size-chart__filter--container__brand");
let brandName = document.querySelector(".size-chart__filter--container__brand--selected").innerText;
const table = document.querySelectorAll(".size-chart");
const verTodo = document.querySelector("#all-button")
$(brand).on("click", function (e) {
    if (e.currentTarget.classList.contains("size-chart__filter--container__brand--selected")) {
    }else {
        $(brandContainer).find(".size-chart__filter--container__brand--selected").removeClass("size-chart__filter--container__brand--selected");
        e.currentTarget.classList.add("size-chart__filter--container__brand--selected");
        brandName = document.querySelector(".size-chart__filter--container__brand--selected").innerText;
        for (let element = 0; element < table.length; element++) {
            const _table = table[element];
            if(_table.getAttribute(brandName)) {
                $(_table).removeClass("size-chart__table--hide")
            }else {
                $(_table).addClass("size-chart__table--hide")
            }
        }
    }
});
$(verTodo).on("click", function (e) {
    for (let element = 0; element < table.length; element++) {
        const _table = table[element];
        $(_table).removeClass("size-chart__table--hide")
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rocket-text-content-slider"] && !Shopify.designMode) return;
  try {
    
    $(".text-content-slider__slider").slick({
        infinite: false,
        variableWidth: true,
        slidesToShow: 1.25,
        slidesToScroll: 1,
        centerMode: false,
        dots: false,
        arrows: true,
        prevArrow:
        '<a class="text-content-slider__slider--arrows__arrow prev" aria-label="' +
        theme.strings.previous +
        '">' +
        theme.icons.chevronLeft +
        "</a>",
        nextArrow:
        '<a class="text-content-slider__slider--arrows__arrow next" aria-label="' +
        theme.strings.next +
        '">' +
        theme.icons.chevronRight +
        "</a>",
        appendArrows: $(".text-content-slider__slider--arrows"),
        draggable: true,
        responsive: {
            576 : {
                slidesToShow: 2.5,
                slidesToScroll: 2,
                centerMode: false
            }
        }
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-chart-table"] && !Shopify.designMode) return;
  try {
    
    let genders = document.querySelectorAll(".size-chart__table--genderSelector__container--option")
    $(genders).on("click", function (e) {
        const sizeChart = e.currentTarget.closest(".size-chart")
        let genderSelected = $(sizeChart).find(".size-chart__table--genderSelector__container--optionSelected")
        genders = $(sizeChart).find(".size-chart__table--genderSelector__container--option")
        if (e.currentTarget.classList.contains(".size-chart__table--genderSelector__container--optionSelected")) {

        }else {
            
            for (let gender = 0; gender < genders.length; gender++) {
                const element = genders[gender];
                element.classList.remove("size-chart__table--genderSelector__container--optionSelected")
            }
            e.currentTarget.classList.add("size-chart__table--genderSelector__container--optionSelected")
            genderSelected = $(sizeChart).find(".size-chart__table--genderSelector__container--optionSelected").attr("id")
        }

    const manTables = $(sizeChart).find(".size-chart__table--container__table--man")
    const womanTables = $(sizeChart).find(".size-chart__table--container__table--woman")
    const childTables = $(sizeChart).find(".size-chart__table--container__table--child")
    if(genderSelected == "man"){
        for (let table = 0; table < womanTables.length; table++) {
            const _table = womanTables[table];
            _table.classList.add("table-hide")
        }
        for (let table = 0; table < childTables.length; table++) {
            const _table = childTables[table];
            _table.classList.add("table-hide")
        }
        for (let table = 0; table < manTables.length; table++) {
            const _table = manTables[table];
            if($(_table).hasClass("table-hide")){
                _table.classList.remove("table-hide")
            }
        }
    }else if(genderSelected == "woman"){
        for (let table = 0; table < manTables.length; table++) {
            const _table = manTables[table];
            _table.classList.add("table-hide")
        }
        for (let table = 0; table < childTables.length; table++) {
            const _table = childTables[table];
            _table.classList.add("table-hide")
        }
        for (let table = 0; table < womanTables.length; table++) {
            const _table = womanTables[table];
            if($(_table).hasClass("table-hide")){
                _table.classList.remove("table-hide")
            }
        }
    }else {
        for (let table = 0; table < manTables.length; table++) {
            const _table = manTables[table];
            _table.classList.add("table-hide")
        }
        for (let table = 0; table < womanTables.length; table++) {
            const _table = womanTables[table];
            _table.classList.add("table-hide")
        }
        for (let table = 0; table < childTables.length; table++) {
            const _table = childTables[table];
            if($(_table).hasClass("table-hide")){
                _table.classList.remove("table-hide")
            }
        }
    }
})

  } catch(e) { console.error(e); }
})();
})();
